import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit {
  categories: any;
  subCategories: any;

  constructor(
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }

  ngOnInit(): void {
    this.loadCategories();
  }

  ngAfterViewInit(): void {
    this.loadReclameAquiSeal();
  }

  loadCategories(): void {
    this.apiService.loadCategories().then((result) => {
      this.categories = result;
    });
  }

  showSubcategory(show: boolean, category: any): void {
    if (show) {
      this.subCategories = category.categorias;
    } else {
      this.subCategories = [];
    }
  }

  private loadReclameAquiSeal(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const target = document.getElementById('ra-verified-seal');
    if (!target) return;

    const oldScript = document.getElementById('ra-embed-verified-seal');
    if (oldScript) {
      oldScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'ra-embed-verified-seal';
    script.type = 'text/javascript';
    script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
    script.setAttribute('data-id', 'Mjk4NjU6Ymx1a2l0');
    script.setAttribute('data-target', 'ra-verified-seal');
    script.setAttribute('data-model', 'horizontal_1');
    script.async = true;

    document.body.appendChild(script);
  }
}